export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHow: "nav-link-how",
  linkCoverage: "nav-link-coverage",
  linkSupport: "nav-link-support",
  ctaWhatsapp: "nav-cta-whatsapp",
  langTrigger: "language-switcher-trigger",
  langOption: (code) => `language-option-${code}`,
};

export const HERO = {
  whatsappBtn: "hero-whatsapp-btn",
  secondaryBtn: "hero-secondary-btn",
};

export const FLOATING = {
  whatsappBtn: "floating-whatsapp-btn",
};

export const SUPPORT = {
  whatsappBtn: "support-whatsapp-btn",
  callBtn: "support-call-btn",
  emailBtn: "support-email-btn",
};
